import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb77fac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-b-overview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Overview", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_5 = { class: "shade mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice Name:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Trading Name:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Branch Address:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "External Examiner Name / Number / Practice Name:", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Relevant Period:", -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.firmName) + " / " + _toDisplayString(_ctx.overviewContent?.firmId), 1),
            _hoisted_7,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.tradingName || 'No trading name found'), 1),
            _hoisted_8,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.branchAddress ?? '-'), 1),
            _hoisted_9,
            (!_ctx.overviewContent?.externalExaminer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.overviewContent?.externalExaminer?.firstName ?? '') + " " + _toDisplayString(_ctx.overviewContent?.externalExaminer?.lastName
        ?? '') + " / " + _toDisplayString(_ctx.overviewContent?.externalExaminer?.lawId ?? '') + " / " + _toDisplayString(_ctx.overviewContent?.externalExaminer?.firmName ??
        ''), 1)),
            _hoisted_12,
            (!_ctx.overviewContent?.complianceYearStart)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "-"))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearStart) || '-') + " - " + _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearEnd) || '-'), 1)
                ]))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}